
import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'light' | 'dark';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    currentTheme = signal<Theme>('dark');

    constructor() {
        // Load saved theme or default to dark
        const savedTheme = localStorage.getItem('theme');
        if (this.isTheme(savedTheme)) {
            this.currentTheme.set(savedTheme);
        }

        // Apply theme whenever it changes
        effect(() => {
            this.applyTheme(this.currentTheme());
        });
    }

    toggleTheme() {
        this.currentTheme.update(current => current === 'dark' ? 'light' : 'dark');
    }

    setTheme(theme: Theme) {
        this.currentTheme.set(theme);
    }

    private applyTheme(theme: Theme) {
        document.documentElement.setAttribute('data-theme', theme);
        document.body.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }

    private isTheme(value: string | null): value is Theme {
        return value === 'light' || value === 'dark';
    }
}
